import moment from 'moment-timezone';
import { computed } from "vue"
import { Detector } from 'detector-js';
import { useGlobalStore } from '@/store/globalStore';
import { useEnvConfigStore } from '@/store/env.store';

export function IsNullorWhiteSpace(obj: string | null | undefined | number | object | unknown) {
    let isNullVal = false
    if (obj !== null && obj !== undefined && obj !== '' && obj !== 'null' && obj !== 'undefined') {
      isNullVal = false
    } else {
      isNullVal = true
    }
    return isNullVal
  }

  
  export function GetBool(data: { toString: () => string } | null | undefined, isAllowNull = false) {
    let value = null
    if (
      data != null &&
      data !== undefined &&
      data.toString() !== '' &&
      data.toString().toLowerCase() === 'true'
    ) {
      value = true
    } else {
      value = isAllowNull === true ? null : false
    }
    return value
  }

  export const formatTime = (data:Date)=>{
    return moment.tz(data,'America/New_York').fromNow()
 }

 export const currentEstTime = computed(()=>{
    return moment().tz("America/New_York")
    })

export function getBrowserDetails(){
  const detector = new Detector();
  const {UserBrowserDetails } = useGlobalStore()
  if(detector){
  UserBrowserDetails.value = {
    BrowserName: detector?.browser?.name,
    BrowserVersion: detector?.browser?.version,
    OSName: detector?.os?.name,
    OSVersion:detector?.os?.version,
    platform:detector?.platform
  }
}
}

export function getRandomNumber() {
  return Math.floor(Math.random() * (12000000000 - 800000000)) + 800000000;
}

export function isValidJSONString(value:string) {
  try {
      JSON.parse(value);
      return true;
  } catch (e) {
      return false;
  }
}

export const removeStyles = (html:any):string => {
  const regex = /style="[^"]*"/g;
  console.log(html.replaceAll(regex, ''))
  return html.replaceAll(regex, '');
};

export function getSupportSiteUrl(isSupportSiteUrl:boolean=true)
{
  let productName = useEnvConfigStore().aiChatBotKeys?.ProductName ?? ""
  const homeSiteUrls:Record<string,string> = useEnvConfigStore().envInfo?.Home_Site || {}
  const supportSiteUrls:Record<string,string> = useEnvConfigStore().envInfo?.Support_Site || {}
  const siteUrls  = isSupportSiteUrl ? supportSiteUrls : homeSiteUrls 
  productName = productName.replace(/\s+/g, '').toLowerCase()

  if(productName?.includes("taxbandits"))
  {
    return siteUrls['TBS']
  }
  else if(productName?.includes("tax990"))
  {
    return  siteUrls['Tax990']
  }
  else if(productName?.includes("wealthrabbit"))
  {
    return  siteUrls['WR']
  }
  else if(productName?.includes("expressextension"))
  {
    return  siteUrls['EE']
  }
  else if(productName?.includes("acawise"))
  {
    return  siteUrls['ACAWise']
  }
}

export function getLabelName()
{
  let productName = useEnvConfigStore().aiChatBotKeys?.ProductName ?? ""
  productName = productName.replace(/\s+/g, '').toLowerCase()

  switch(true)
  {
    case productName?.includes("taxbandits"):
      return "taxbandits";
    case productName?.includes("tax990"):
      return "tax990";
    case productName?.includes("wealthrabbit"):
      return "wealthrabbit";
    case productName?.includes("expressextension"):
      return "expressextension";
    case productName?.includes("acawise"):
      return "acawise";
  }
}